import z from "zod";

const LOCALE_FLAGS_SCHEMA = z.record(z.string(), z.enum(["0", "1"]));

const ENV_VAR_NAME = "NEXT_PUBLIC_GEOGRAPHICAL_AREA_FILTERING_ENABLED";

/** "0" / "1" applies to the whole tenant; the object enables filtering per locale. */
export type GeographicalAreaFilteringConfig = boolean | Record<string, boolean>;

export const parseGeographicalAreaFilteringConfig = (rawValue?: string): GeographicalAreaFilteringConfig => {
  if (rawValue === "1") {
    return true;
  }

  if (!rawValue || rawValue === "0") {
    return false;
  }

  let parsedValue: unknown;

  try {
    parsedValue = JSON.parse(rawValue);
  } catch {
    console.error(`Invalid ${ENV_VAR_NAME}: "${rawValue}" is neither "0"/"1" nor a per-locale JSON map.`);
    return false;
  }

  const localeFlags = LOCALE_FLAGS_SCHEMA.safeParse(parsedValue);

  if (!localeFlags.success) {
    console.error(`Invalid ${ENV_VAR_NAME}: expected a per-locale map such as {"en":"1","fr":"0"}.`);
    return false;
  }

  const localeFlagEntries = Object.entries(localeFlags.data);
  const localeFilteringEntries = localeFlagEntries.map(([locale, flag]): [string, boolean] => [locale, flag === "1"]);
  const localeFilteringConfig: GeographicalAreaFilteringConfig = Object.fromEntries(localeFilteringEntries);

  return localeFilteringConfig;
};

export const checkIsGeographicalAreaFilteringEnabled = (
  config: GeographicalAreaFilteringConfig,
  locale: string
): boolean => {
  if (typeof config === "boolean") {
    return config;
  }

  return config[locale] === true;
};
